import { Box, Typography } from '@mui/material';
import { TextLink, monoSm } from './Section';
import type { Cta, ToolStatus } from './copy';

type Props = {
  name: string;
  /** Plain mono word, never a badge or a pill. */
  status: ToolStatus;
  what: string;
  forWhom: string;
  link?: Cta;
};

export function PlateCard({ name, status, what, forWhom, link }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        backgroundColor: 'var(--bg-elevated)',
        border: '1px solid var(--rule)',
        borderRadius: '2px',
        p: { xs: 3, md: 3.5 },
      }}
    >
      {/* Two title lines' worth of height so every card body starts on the same line. */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 2,
          minHeight: { md: 58 },
        }}
      >
        <Typography variant="h3" component="h3">
          {name}
        </Typography>
        <Box
          component="span"
          sx={{
            ...monoSm,
            flexShrink: 0,
            color: status === 'live' ? 'var(--success)' : 'var(--ink-muted)',
          }}
        >
          {status}
        </Box>
      </Box>

      <Typography variant="body2" sx={{ mt: 2 }}>
        {what}
      </Typography>
      <Typography variant="body2" sx={{ mt: 1.5, color: 'var(--ink-muted)' }}>
        {forWhom}
      </Typography>

      {link && (
        <TextLink
          to={link.to}
          sx={{ alignSelf: 'flex-start', mt: 'auto', pt: 3, fontSize: '0.875rem' }}
        >
          {link.label}
        </TextLink>
      )}
    </Box>
  );
}
